export const HOME_URL = "home";
export const DASHBOARD_URL = "dashboard";
export const SERVICE_REQUEST_BASE_URL = "service-request";
export const BUDGET_BASE_URL = "budget";
